import { bootstrapApplication } from '@angular/platform-browser'
import {
  RouteReuseStrategy,
  provideRouter,
  PreloadAllModules,
  withPreloading,
} from '@angular/router'
import {
  Platform,
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone'

import { routes } from './app/app.routes'
import { routes as desktopRoutes } from './app/app-desktop.routes'

import { AppComponent } from './app/app.component'
import { isDevMode, InjectionToken } from '@angular/core'
import { provideServiceWorker } from '@angular/service-worker'
import { provideHttpClient } from '@angular/common/http'

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(
      routes, // Provide the default routes initially
      withPreloading(PreloadAllModules)
    ),
    {
      provide: 'appRoutes',
      useFactory: (platform: Platform) => {
        if (platform.is('desktop')) {
          provideRouter(desktopRoutes, withPreloading(PreloadAllModules))
        }
      },
      deps: [Platform],
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideHttpClient(),
  ],
}).catch((err) => console.error('Error bootstrapping app:', err))
